import { Button, Col, Row, Select, List, Card, Image, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { recordError } from '../../utils/logService';
import '../citizenscience/project-join/joinProject.css';
import util from "../../utils/functions/custom";
import service from '../../services/citizenscienceService';
import { ClockCircleOutlined, PlusOutlined, CloseCircleFilled, CheckCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import { openNotification } from '@seims/shared';
import { Messages, Notify } from "../../services/custom/Messages";

import moment from "moment";
import CloseProjectModal from './projectinfo/CloseProjectModal';

export default function ProjectListHome() {
    let msg = "";
    const entity = "Project";
    let navigate = useNavigate();
    let path = `/citizen-scientist/home`;
    const [filteredData, setFilteredData] = useState([]);
    const [projects, setProjects] = useState([]);
    const [projectStatuses, setProjectStatuses] = useState([]);
    const [defaultValue, setDefaultValue] = useState("Status");
    const [disabled, setDisabled] = useState(true);
    const [selectedProjectId, setSelectedProjectId] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [projectData, setProjectData] = useState({});

    const { Option } = Select;
    let confirmData = {};
    useEffect(() => {
        getProjectStatuses();
        getProjects();
    }, [])

    const getProjectStatuses = async () => {
        try {
            const response = await service.getProjectStatuses();
            if (response && response.status === 200) {
                const { data } = response;
                data.unshift(
                    { key: -1, value: "All" }
                );
                setProjectStatuses(data);
            } else {
                setProjectStatuses([]);
            }

        } catch (error) {
            recordError(error);
        }
    };

    const getProjects = async () => {
        try {
            const response = await service.getProjects();
            if (response && response.status === 200) {
                const { data } = response;
                const projects = data.map((project) => ({
                    name: project.name,
                    lastModified: moment(project.lastModified).format("YYYY-MM-DD"),
                    status: project.status,
                    id: project.id,
                    description: project.description,
                    uuid: project.uuid
                }));
                setFilteredData(projects);
                setProjects(projects);
            } else {
                setFilteredData([]);
            }

        } catch (error) {
            recordError(error);
        }
    }

    const onStatusChange = (key) => {
        try {
            if (key === undefined || key == -1) {
                setFilteredData(projects);
                return;
            }
            let keyVal = parseInt(key);
            const keyValue = projectStatuses.find(projStatus => projStatus.key === keyVal);
            var dataf = projects.filter(data => data.status === keyValue.value);
            setFilteredData(dataf);
            setDefaultValue(dataf);
        } catch (error) {
            recordError(error);
        }
    };

    const onAddProject = () => {
        navigate(path);

    }

    const editProject = (id) => {
        const participant = projects.find((participant) => {
            return participant.id === id
        });
        let uuid = participant.uuid;
        navigate(`/view-project/${id}${"&"}${uuid}`);
    }

    const handleCloseProject = (id) => {
        var proj = projects.find((project) => project.id == id);
        console.log("proj ", proj);
        if (proj !== undefined) {
            confirmData = {
                "projectName": proj.name,
                "id": id
            }
            setProjectData(confirmData);
            setShowModal(true);
        }
        setSelectedProjectId(id);
        setDisabled(false);
    };

    const cancel = () => {
        var msg = util.parseMessage(Messages.UPDATE_CANCELLED);
        openNotification("Action cancelled successfully", msg, Notify.ERROR);
    };
    const handleConfirmCloseProject = async () => {
        console.log("Project id ...", selectedProjectId);
        const comment = {
            "action": "CONCLUDE",
            "notes": "Close project"
        }
        const response = await service.closeProject(comment, selectedProjectId);

        if (response && (response.status == 201 || response.status == 200)) {
            msg = util.parseMessage(Messages.CLOSE_SUCCESS, entity);
            openNotification(entity, msg, Notify.SUCCESS);
            getProjects();
        } else {
            msg = util.parseMessage(Messages.ADD_FAILURE, entity);
            openNotification(entity, msg, Notify.ERROR);
        }
    }
    const handleCancel = () => {
        setDisabled(true);
        setSelectedProjectId(0);
        setShowModal(false);
    };


    const handleModalSubmit = async (values) => {
        try {
            if (values.feedback) {
                const retData = {
                    "action": "CONCLUDE",
                    "notes": values.comment
                }
                const request = await service.closeProject(
                    retData,
                    values.id
                );

                if (request?.status == 200 || request?.status == 201) {
                    msg = util.parseMessage(Messages.CLOSE_SUCCESS,"Project");
                    openNotification("Close Project", msg, Notify.SUCCESS);
                }

                getProjects();
            }
            setShowModal(false);
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE);
            openNotification("Close Project", msg, Notify.ERROR);
            recordError(error);
        };
    };


    return (
        <div className=''>
            <Row>
                <Col xs={24}>
                    <div className="public-portal-section">
                        <h2> Citizen Science - My Projects</h2>
                    </div>
                </Col>
            </Row>
            <Card className='join-project-card'>
                <Row>
                    {/* <Col xs={4} md={4}>

                    </Col> */}
                    <Col xs={4} md={2}>
                        Filter By:
                    </Col>
                    <Col xs={7} md={6}>
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Status"
                            onSelect={onStatusChange}
                            onChange={onStatusChange}
                            optionFilterProp="children"
                            defaultValue={defaultValue}
                        >
                            {projectStatuses.map((statuses) => (
                                <Option key={statuses.key}>{statuses.value}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col xs={13} md={16}>
                        <Button key="1" className="right-align-button add-button" shape="round" type="primary" onClick={onAddProject} icon={<PlusOutlined />}>
                            Add New Project
                        </Button>
                    </Col>
                </Row>
                <div className="space"></div>
                <List
                    itemLayout="vertical"
                    pagination={{
                        pageSize: 5,
                    }}
                    dataSource={filteredData}
                    renderItem={(project) => (
                        <List.Item
                            key={project.key}
                        >
                            <Card className="card-border project-single">
                                <Row>
                                    <Col xs={4} md={4} className="project-img-container">
                                        {(project.status === "Approved") ? (
                                            <Image
                                                style={{ paddingRight: "10px" }}
                                                src={require("../../assets/project-1.png")}
                                                preview={false}
                                            />
                                        ) : (
                                            <Image
                                                style={{ paddingRight: "10px" }}
                                                src={require("../../assets/project-2.png")}
                                                preview={false}
                                            />
                                        )}
                                    </Col>
                                    <Col xs={24} md={20} className="project-details">
                                        <Row>
                                            <Col>
                                                {<h2><b>{project.name}</b></h2>}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} sm={7} md={7}>
                                                {(project.status === "Approved") && (
                                                    <CheckCircleFilled style={{ color: "#2db83d" }} />

                                                )}
                                                {(project.status === "Submitted") && (
                                                    <PlusCircleFilled style={{ color: "#0f52ba" }} />
                                                )}
                                                {(project.status === "In Review") && (
                                                    <CheckCircleFilled style={{ color: "#c67bc4" }} />
                                                )}
                                                {(project.status === "Rejected") && (
                                                    <CloseCircleFilled style={{ color: "#cf352e" }} />
                                                )}
                                                {(project.status === "Closed") && (
                                                    <CloseCircleFilled style={{ color: "#808080" }} />
                                                )}
                                                <span style={{ paddingLeft: "5px" }}></span>Project Status : {project.status}
                                            </Col>
                                            <Col xs={12} sm={9} md={9}>
                                                <ClockCircleOutlined style={{ color: '#009aa6' }} /> <span style={{ paddingLeft: "5px" }}></span>Last Updated : {project.lastModified}
                                            </Col>
                                            {(project.status !== "Rejected" && project.status !== "Closed") ? (
                                                <Col xs={12} sm={8} md={8}>
                                                    <Button className="right-align-button edit-button" shape="round" type="primary"  style={{ marginBottom: "8px" }} onClick={() => editProject(project.id)}>
                                                        View/Edit
                                                    </Button>
                                                </Col>

                                            ) : (
                                                <Col xs={12} sm={8} md={8}>
                                                    <Button className="right-align-button edit-button" shape="round" type="primary" onClick={() => editProject(project.id)}>
                                                        View
                                                    </Button>
                                                </Col>
                                            )}

                                        </Row>
                                        <Row>
                                            <Col xs={20} md={20}>
                                                {project.description}
                                            </Col>
                                            {(project.status === "Approved") && (

                                                <Col xs={4} md={4}>
                                                    <Popconfirm
                                                        title="Are you sure you want to close this project?"
                                                        onConfirm={() => handleCloseProject(project.id)}
                                                        onCancel={() => cancel()}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <Button
                                                            className="right-align-button close-button"
                                                            shape="round" type="primary" 
                                                        >
                                                            Close
                                                        </Button>
                                                    </Popconfirm>
                                                </Col>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>

                            </Card>
                        </List.Item>
                    )}
                />
            </Card>

            <Row>
                <Col xs={24}>
                    <CloseProjectModal
                        data={projectData}
                        visible={showModal}
                        onCancel={handleCancel}
                        onModalSubmit={handleModalSubmit}
                    />
                </Col>
            </Row>

        </div>
    )
}
